import { cn } from "@theprelude/core";

export const GoogleIconPlain: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.5367 6.69303H13.9997V6.66536H7.99967V9.33203H11.7673C11.2177 10.8844 9.74067 11.9987 7.99967 11.9987C5.79067 11.9987 3.99967 10.2077 3.99967 7.9987C3.99967 5.7897 5.79067 3.9987 7.99967 3.9987C9.01934 3.9987 9.94701 4.38336 10.6533 5.0117L12.539 3.12603C11.3483 2.01636 9.75567 1.33203 7.99967 1.33203C4.31801 1.33203 1.33301 4.31703 1.33301 7.9987C1.33301 11.6804 4.31801 14.6654 7.99967 14.6654C11.6813 14.6654 14.6663 11.6804 14.6663 7.9987C14.6663 7.5517 14.6203 7.11537 14.5367 6.69303Z" />
  </svg>
);
